class WishlistQuantityCart extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.increaseQuantity = this.increaseQuantity.bind(this)
    this.els.increase.element.addEventListener('click', this.increaseQuantity)

    this.decreaseQuantity = this.decreaseQuantity.bind(this)
    this.els.decrease.element.addEventListener('click', this.decreaseQuantity)

    this.inputChanged = this.inputChanged.bind(this)
    this.els.input.element.addEventListener('change', this.inputChanged)
  }

  increaseQuantity (e) {
    e.preventDefault()

    this.quantity = this.quantity + 1
  }

  decreaseQuantity (e) {
    e.preventDefault()

    this.quantity = this.quantity - 1
  }

  async inputChanged (e) {
    let value = e.target.value
    value = value < 1 ? 1 : value
    value = value > 99 ? 99 : value

    e.target.value = value

    await this.saveValue(value)
  }

  async saveValue (value) {
    this.externalEls.quantity.element.value = value
  }

  get quantity () {
    return parseInt(this.els.input.element.value)
  }

  set quantity (value) {
    this.els.input.element.value = value

    const changeEvent = new Event('change')
    this.els.input.element.dispatchEvent(changeEvent)
  }
}

customElements.define('wishlist-quantity-cart', WishlistQuantityCart)
